import { Injectable } from '@angular/core';
import { NaturalDisasterRxDto } from '../api-service/register/natural-disaster-rx-dto';
import { ObjectCacheService } from './icache-service';
import { EasyNotificationService } from '../easy-notification.service';
import { RegisterApi } from '../api-service/register/register-api';

@Injectable({
  providedIn: 'root'
})

/**
 * 系統參數快取Service。
 * @implements {ICacheService<ParamType, Map<ParamType, any>>}
 */
export class NaturalDisasterRxCachedService extends ObjectCacheService<NaturalDisasterRxObject> {

  protected notifyMsgOnUpdated: string = '暫存內容已變更…';
  protected notifyMsgOnReload: string = '已重載暫存內容'
  /**
   * 建構子，初始化服務。
   * @param {ParameterApi} parameterApi - 用於獲取參數的 API 服務。
   * @param {EasyNotificationService} notifyService - 用於顯示通知的服務。
   */
  constructor( 
    private registerApi: RegisterApi,
    private notifyService: EasyNotificationService) {
    super(notifyService);
  }

  protected async getCacheObject<k extends string|number>(keys: k[]): Promise<Map<k, NaturalDisasterRxDto[]>> {
    var m:Map<k, NaturalDisasterRxDto[]> = new Map();
    for(let d of keys){
      var ret = await this.registerApi.GetNaturalDisasterRx(new Date(d));
      m.set(d,ret);
    }
    return m;
  }
}
declare type NaturalDisasterRxObject = {[key:string]:NaturalDisasterRxDto[]}
